import { Plugin } from "vue";
import { useUserStore } from "~stores/User.ts";

const plugin: Plugin = {
  install: (app, options) => {
    // inject a globally available $translate() method
    app.config.globalProperties.$isAllowed = (privilege) => {
      const { isAllowed } = useUserStore();

      return isAllowed(privilege);
    };
  }
};

export default plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    $isAllowed: (privilege: string) => boolean;
  }
}
